import request from "@/utils/request";

// 获取订单列表
export function getOrderList(data) {
  return request({
    method: "post",
    path: "order/lists",
    data,
  });
}

//订单状态统计
export function getOrderStatusStat(data) {
  return request({
    method: "post",
    path: "order/getOrderStatusStat",
    data,
  });
}

// 获取订单详情
export function getOrderDetail(data) {
  return request({
    method: "post",
    path: "order/detail",
    data,
  });
}

// 获取订单预览
export function getOrderPreview(data) {
  return request({
    method: "post",
    path: "order/preview",
    data,
  });
}

// 获取可用优惠券列表
export function getCouponList(data) {
  return request({
    method: "post",
    path: "order/getCouponList",
    data,
  });
}

// 创建订单
export function addOrder(data) {
  return request({
    method: "post",
    path: "order/add",
    data,
  });
}

// 取消订单
export function cancelOrder(data) {
  return request({
    method: "post",
    path: "order/cancel",
    data,
  });
}

// 确认订单
export function setSure(data) {
  return request({
    method: "post",
    path: "order/setSure",
    data,
  });
}

// 申请复测
export function setService(data) {
  return request({
    method: "post",
    path: "order/setService",
    data,
  });
}

// 订单确认完成
export function setFinish(data) {
  return request({
    method: "post",
    path: "order/setFinish",
    data,
  });
}

// 设为已发货
export function setExpress(data) {
  return request({
    method: "post",
    path: "order/setExpress",
    data,
  });
}

// 加入草稿箱
export function addDrafts(data) {
  return request({
    method: "post",
    path: "order/addDrafts",
    data,
  });
}

// 加入回收站
export function setRecycle(data) {
  return request({
    method: "post",
    path: "order/setRecycle",
    data,
  });
}

//订单统计
export function getOrderStatCount(data) {
  return request({
    method: "post",
    path: "order/getOrderStatCount",
    data,
  });
}

// 获取还款预览
export function getRepaymentPreview(data) {
  return request({
    method: "post",
    path: "order/getRepaymentPreview",
    data,
  });
}
